import { useWindowOpen } from '@repo/platform';
import { useUserEventLogger } from '@repo/tracking-service';
import { BottomDrawer, Button, Description, Guide } from '@zenterprise-inc/ui';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { 네이버앱인증서설치안내링크 } from '@/lib/constants/link';
import { useFromTypeStaticData } from '@/lib/hooks/use-simple-auth-from-type';
import { simpleAuthFromTypeAtom } from '@/lib/stores/simple-auth';

interface Props {
  isVisible: boolean;
  onClose: () => void;
}

const LIST_CONTENTS = [
  '먼저, 입력하신 휴대폰번호에 네이버 앱이 설치되어 있는지 확인해주세요.',
  '네이버 인증서가 기기에 등록되어 있어야 가능해요. 네이버 앱에서 인증서 설치 및 최초 1회 인증을 완료하고서 다시 진행해주세요.'
];

export const NaverAppInstallCheckDrawer = ({ isVisible, onClose }: Props) => {
  const simpleAuthFromType = useAtomValue(simpleAuthFromTypeAtom);
  const { openWindow } = useWindowOpen();
  const { sendClickEvent, sendViewEvent } = useUserEventLogger();
  const { getNaverAppInstallDrawerEvent } = useFromTypeStaticData(simpleAuthFromType);
  const events = getNaverAppInstallDrawerEvent();

  useEffect(() => {
    if (isVisible) {
      sendViewEvent(events.view, undefined, { isAllowRetry: true });
    }
  }, [isVisible, sendViewEvent, events.view]);

  return (
    <BottomDrawer.Basic isVisible={isVisible} onCloseDrawer={onClose} backDropClose={false}>
      <BottomDrawer.Basic.Contents isBottomButton={false}>
        <div className={'pt-3'}>
          <Description.Guide
            title={'네이버로 인증하려면 확인이 필요해요'}
            imgChild={
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_exclamation-mark_md.svg`} alt={'네이버 인증 확인'} width={80} height={80} />
            }
          />
        </div>
        <Guide className={'!py-0 !px-4.5'}>
          <Guide.Description>
            <ul className={'text-left flex flex-col gap-2.5'}>
              {LIST_CONTENTS.map((text, i) => (
                <li key={i} className={'flex gap-2'}>
                  <span className={'shrink-0 flex items-center justify-center w-5 h-5 text-12 text-gray-700 font-bold tracking-tighter leading-3'}>
                    {i + 1}.
                  </span>
                  <p className={'break-all body-14 text-gray-700 leading-5'}>{text}</p>
                </li>
              ))}
            </ul>
          </Guide.Description>
        </Guide>
        <div className="page-padding flex-col items-center text-gray-700 pt-8">
          <Button.StickyBottom.Button
            state="primary"
            onClick={() => {
              sendClickEvent(events.clickOk);
              onClose();
            }}
          >
            확인했어요
          </Button.StickyBottom.Button>
          <div className="mb-3" />
          <div className="flex justify-center">
            <Button.Text
              state="gray"
              icon="arrow-right"
              onClick={() => {
                sendClickEvent(events.clickGuide);
                openWindow(네이버앱인증서설치안내링크);
              }}
            >
              <span className="underline text-gray-700">네이버 앱 인증서 설치 안내보기</span>
            </Button.Text>
          </div>
          <div className="mb-1" />
        </div>
      </BottomDrawer.Basic.Contents>
    </BottomDrawer.Basic>
  );
};
